// The default fallback value: all text-like cell components will display
// this if their data is null (not in case of an empty string).
export const emptyTextFallback = '\u2013'
